/**
 * The detail read is on the user resource, not a `/locations` sub-resource: the shipped contract puts
 * the current assignment inside `GET /api/v1/users/{userId}` (`paths/user_by_id.yml`, operationId
 * `get-user`). Only the write lives at `/locations`.
 */
export const userDetailEndpoint = (userId: string) => `api/v1/users/${userId}`;

export const bulkUserLocationsEndpoint = 'api/v1/users/locations';
